export const USER_ROLES = [
  'ROLE_ORGANIZATION_OWNER',
  'ROLE_ORGANIZATION_ADMIN',
  'ROLE_ORGANIZATION_MEMBER',
] as const

export type UserRoles = (typeof USER_ROLES)[number]

export const SIDEBAR_WIDTH = 300
/* if you change that change also --sidebar-width in index.css!! */

//issues gallery
const padding = 16

export const GALLERY_SM_CONTENT = 92 + 12 + 12 + padding
export const GALLERY_BIG_CONTENT = 96 + 12 + 12 + padding

// MAP
export const MAP_MAX_ZOOM = 5
export const MAP_MIN_ZOOM = -2
export const MAP_ZOOM_SNAP = 0.5

export const MAP_ALLOW_MAX_ZOOM = 5
export const MAP_ZOOM = 1

export const MAX_IMAGE_FILE_SIZE = 10 * 1024 * 1024
export const STALE_TIME = 1000 // 1 second
export const STALE_TIME_LONG = 1000 * 3 // 3 seconds

// full card size (img + content) in px
// export const GALLERY_CARD_SMALL_HEIGHT = GALLERY_SM_CONTENT + GALLERY_IMG_SM_SIZE + padding
// export const GALLERY_CARD_BIG_HEIGHT = GALLERY_BIG_CONTENT + GALLERY_IMG_BIG_SIZE + padding

export const GALLERY_CARD_BIG_WIDTH = 340 + padding
export const GALLERY_CARD_SMALL_WIDTH = 162 + padding

export const PROJECT_SETTINGS_STATUSES = [
  'PLANNED',
  'IN_PROGRESS',
  'DONE',
  'ON_HOLD',
  'COMPLETED',
] as const

export const LOCATION_SEPARATOR = ';'

export const FORCE_LAST_SELECTED_LOCATION = 'forceLastSelectedLocation'
export const LOCAL_STORAGE_MAP_CENTER = 'leafletMapCenter'
export const LOCAL_STORAGE_MAP_ZOOM = 'leafletMapZoom'
export const LOCAL_STORAGE_LAST_SELECTED_LOCATION_KEY = 'lastSelectedMapLocation'
export const LOCAL_STORAGE_APP_VERSION = 'app_version'
export const LOCAL_STORAGE_LANG_KEY = 'buildLogLang'
